<template v-cloak>
    <NuxtLayout name="main" :class="$i18n.locale">
        <section class="header-container">
            <div class="container">
                <div class="title-bg">ABOUT RDDC</div>
                <div class="title font-bold">{{ $t("AboutI18n.Title") }}</div>
            </div>
        </section>

        <section class="content-container container">
            <h2 v-html="$t('AboutI18n.Section1')"></h2>
            <div class="descript" v-html="$t('AboutI18n.Descript1')"></div>
            <div v-if="$i18n.locale === 'en'" class="descript summarys" v-html="$t('AboutI18n.Descript101')"></div>
            <div v-if="$i18n.locale === 'en'" class="descript summarys" v-html="$t('AboutI18n.Descript102')"></div>
            <div class="descript summarys" v-html="$t('AboutI18n.Descript11')"></div>

            <div class="summarys">
                <div class="summarys-container">
                    <div class="summarys-title" v-html="$t('AboutI18n.Descript12')"></div>
                    <div class="summary-items">
                        <div class="summary-item" v-html="$t('AboutI18n.Descript13')"></div>
                        <div class="summary-item" v-html="$t('AboutI18n.Descript14')"></div>
                        <div class="summary-item" v-html="$t('AboutI18n.Descript15')"></div>
                        <div class="summary-item" v-html="$t('AboutI18n.Descript16')"></div>
                        <div class="summary-item" v-html="$t('AboutI18n.Descript17')"></div>
                        <div class="summary-item" v-html="$t('AboutI18n.Descript18')"></div>
                        <div class="summary-item" v-html="$t('AboutI18n.Descript20')"></div>
                        <div class="summary-item" v-html="$t('AboutI18n.Descript21')"></div>
                        <div class="summary-item" v-html="$t('AboutI18n.Descript22')"></div>
                        <div class="summary-item" v-html="$t('AboutI18n.Descript23')"></div>
                        <div class="summary-item" v-html="$t('AboutI18n.Descript24')"></div>
                    </div>
                </div>
            </div>

            <div class="summarys">
                <div class="summarys-container">
                    <div class="summarys-title" v-html="$t('AboutI18n.Descript25')"></div>
                    <div class="summary-items">
                        <div class="summary-item" v-html="$t('AboutI18n.Descript26')"></div>
                        <div class="summary-item" v-html="$t('AboutI18n.Descript27')"></div>
                        <div class="summary-item" v-html="$t('AboutI18n.Descript29')"></div>
                        <div class="summary-item" v-html="$t('AboutI18n.Descript30')"></div>
                        <div class="summary-item" v-html="$t('AboutI18n.Descript31')"></div>
                        <div class="summary-item" v-html="$t('AboutI18n.Descript32')"></div>
                        <div class="summary-item" v-html="$t('AboutI18n.Descript33')"></div>
                    </div>
                </div>
            </div>

            <div class="summarys">
                <div class="summarys-container">
                    <div class="summarys-title" v-html="$t('AboutI18n.Descript34')"></div>
                    <div class="summary-items">
                        <div class="summary-item" v-html="$t('AboutI18n.Descript35')"></div>
                        <div class="summary-item" v-html="$t('AboutI18n.Descript36')"></div>
                        <div class="summary-item" v-html="$t('AboutI18n.Descript37')"></div>
                        <div class="summary-item" v-html="$t('AboutI18n.Descript38')"></div>
                        <div class="summary-item" v-html="$t('AboutI18n.Descript39')"></div>
                    </div>
                </div>
            </div>

            <div class="summarys">
                <div class="descript" v-html="$t('AboutI18n.Descript40')"></div>
                <div v-if="$i18n.locale === 'en'" class="descript summarys" v-html="$t('AboutI18n.Descript401')"></div>
                <div class="img-Collections">
                    <div style="width: 32.5%">
                        <div class="img-title" v-html="$t('AboutI18n.Descript41')"></div>
                        <img v-if="$i18n.locale === 'en'" src="@/assets/images/about/en/about2.png" class="summary-img" />
                        <img v-else src="@/assets/images/about/zh/about2.png" class="summary-img" />
                    </div>
                    <div style="width: 32.5%">
                        <div class="img-title" v-html="$t('AboutI18n.Descript42')"></div>
                        <img v-if="$i18n.locale === 'en'" src="@/assets/images/about/en/about3.png" class="summary-img" />
                        <img v-else src="@/assets/images/about/zh/about3.png" class="summary-img" />
                    </div>
                    <div style="width: 32.5%">
                        <div class="img-title" v-html="$t('AboutI18n.Descript43')"></div>
                        <img v-if="$i18n.locale === 'en'" src="@/assets/images/about/en/about4.png" class="summary-img" />
                        <img v-else src="@/assets/images/about/zh/about4.png" class="summary-img" />
                    </div>
                </div>
                <div class="img-descript" v-html="$t('AboutI18n.Descript44')"></div>
            </div>

            <div class="summarys">
                <div class="summarys-container">
                    <div class="summarys-title" v-html="$t('AboutI18n.Descript45')"></div>
                    <div class="summary-items" style="margin: 0">
                        <div class="summary-item" style="display: block" v-html="$t('AboutI18n.Descript46')"></div>
                        <div class="summary-item" style="display: block" v-html="$t('AboutI18n.Descript47')"></div>
                        <div class="summary-item" style="display: block" v-html="$t('AboutI18n.Descript49')"></div>
                        <div class="summary-item" style="display: block" v-html="$t('AboutI18n.Descript50')"></div>
                        <div class="summary-item" style="display: block" v-html="$t('AboutI18n.Descript52')"></div>
                    </div>
                </div>
            </div>
        </section>

        <section class="content-container container">
            <h2 v-html="$t('AboutI18n.Section2')"></h2>
            <div class="descript" v-html="$t('AboutI18n.Descript201')"></div>
            <div v-if="$i18n.locale === 'en'" class="descript summarys" v-html="$t('AboutI18n.Descript208')"></div>
            <div class="summarys">
                <div class="img-Collections">
                    <div style="width: 27.8%">
                        <div style="height: 64px" class="img-title" v-html="$t('AboutI18n.Descript202')"></div>
                        <img v-if="$i18n.locale === 'en'" src="@/assets/images/about/en/about5.png" class="summary-img" />
                        <img v-else src="@/assets/images/about/zh/about5.png" class="summary-img" />
                    </div>
                    <div style="width: 70.7%">
                        <div style="height: 64px" class="img-title" v-html="$t('AboutI18n.Descript203')"></div>
                        <img v-if="$i18n.locale === 'en'" src="@/assets/images/about/en/about6.png" class="summary-img" />
                        <img v-else src="@/assets/images/about/zh/about6.png" class="summary-img" />
                    </div>
                </div>
                <div class="img-descript" v-html="$t('AboutI18n.Descript204')"></div>
            </div>

            <div class="descript summarys" v-html="$t('AboutI18n.Descript205')"></div>
            <div class="descript summarys" v-html="$t('AboutI18n.Descript206')"></div>
            <div v-if="$i18n.locale === 'en'" class="descript summarys" v-html="$t('AboutI18n.Descript207')"></div>
            <div class="descript summarys" v-html="$t('AboutI18n.Descript209')"></div>
        </section>
    </NuxtLayout>
</template>

<style lang="less" scoped>
// 中文格式
.zh {
    h2 {
        background: url("@/assets/images/about/zh/title-cover.png") left no-repeat;
        background-size: contain;
    }
}

// 英文格式
.en {
    h2 {
        background: url("@/assets/images/about/en/title-cover.png") left no-repeat;
        background-size: contain;
    }

    .header-container {
        padding-top: 0;

        .title-bg {
            display: none;
        }
    }
}

.header-container {
    padding-top: 44px;
    display: flex;
    align-items: center;
    width: 100%;
    height: 240px;
    background: url("https://rdgta.cdn.cyagen.com/rddc/images/about/header-cover.png") center no-repeat;
    background-size: cover;
    overflow: hidden;

    .container {
        position: relative;
    }

    .title-bg {
        position: absolute;
        top: -44px;
        left: 0;
        font-weight: bold;
        font-size: 80px;
        line-height: 70px;
        background-image: -webkit-linear-gradient(rgba(255, 255, 255, 0.8) 0%, rgba(255, 255, 255, 0) 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        opacity: 0.24;
    }

    .title {
        font-size: 56px;
        color: #ffffff;
        line-height: 1;
        color: #ffffff;
    }
}

.content-container {
    margin: 88px auto 0;

    &:nth-child(2) {
        margin: 80px auto 0;
    }

    *:last-child {
        margin-bottom: 0;
    }

    h2 {
        box-sizing: border-box;
        position: relative;
        padding-left: 24px;
        margin: 0 0 32px;
        height: 48px;
        line-height: 48px;
        color: #ffffff;
        border-radius: 4px;
        font-size: 18px;
    }

    .descript {
        line-height: 30px;
    }

    .img-Collections {
        margin: 40px 0 0;
        display: flex;
        justify-content: space-between;
    }

    .summarys {
        margin: 32px 0 0;

        .img-title {
            margin: 0 0 24px;
            font-size: 16px;
            line-height: 32px;
            font-weight: bold;
            color: var(--uicolor-font-1);
            text-align: center;
        }

        .img-descript {
            margin: 40px 0 48px;
            text-align: center;
        }

        .summary-img {
            // max-width: 100%;
            width: 100%;
        }

        .summary-item {
            margin: 0 0 16px;
            display: flex;
            padding: 0 0 0 12px;
            position: relative;
            align-items: center;
            color: var(--uicolor-font-1);

            &::before {
                top: 12px;
                left: 0;
                width: 4px;
                height: 4px;
                content: "";
                position: absolute;
                background: var(--uicolor-font-1);
                border-radius: 50%;
            }

            &:last-child {
                margin: 0;
            }
        }

        .summary-items {
            margin-bottom: 32px;
        }

        .summarys-title {
            margin: 0 0 16px;
            display: flex;
            transition: all 0.3s;
            align-items: center;
        }

        *:last-child {
            margin-bottom: 0;
        }
    }
}
</style>
